import React from 'react';
import AdminLayout from '../components/AdminLayout';
import AdminChat from '../components/AdminChat';
import '../components/AdminChat.css';

const AdminAssistantPage = () => (
  <AdminLayout>
    <div className="w-full h-[calc(100vh-64px)] min-h-[600px]" data-testid="admin-assistant-page">
      <AdminChat />
    </div>
  </AdminLayout>
);

export default AdminAssistantPage;
